/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Button } from '../../../components/Button';
import { useColors } from '../../../hooks/useColors';
import { SizeEnum } from '../../../lib/constants';
import { Icons } from '../../../types';
import { IconWithTooltip } from '../../../molecules/IconWithTooltip';

interface IReservationHistoryLinkProps {
	reservationId: number;
	reservationCreatedAt: string;
	ariaLabel: string;
	tooltip: string;
	onOpen: (reservationId: number, reservationCreatedAt: string) => void;
}

const ICON_SIZE = 20;
export const ReservationHistoryLink = ({
	reservationId,
	reservationCreatedAt,
	ariaLabel,
	tooltip,
	onOpen,
}: IReservationHistoryLinkProps) => {
	const { colors } = useColors();

	return (
			<Button
				theme="basic"
				sizer={SizeEnum.EXTRA_SMALL}
				padding="0"
				data-testid="slot-popup-reservation-history-link"
				aria-label={ariaLabel}
				onClick={() => onOpen(reservationId, reservationCreatedAt)}
			>
				<IconWithTooltip size={ICON_SIZE} icon={Icons.history} text={tooltip} isTopLayer={true} color={colors.tx_info!} />
			</Button>
	);
};
